import styled from "@emotion/styled";

export const Summary = styled.div`
    margin-top: 15px;
    padding: 0 5px;
`

export const Total = styled.div`
    
    display: flex;
    font-size: 14px;
    justify-content: space-between;
    padding-top: ${({theme}) => theme.spacing.md};
    padding-bottom: ${({theme}) => theme.spacing.md};

    h5 {
        font-weight: 700;
        
        margin: unset;
        color: #54565A;
    }
`;

export const TotalPrice = styled.span`
    font-weight: 700;
    color: #000;
    font-size: 20px;
    line-height: 20px ;
`;

export const TaxInfo = styled.span`
  font-weight: 500;
  color: #000;
  font-size: 13px;
  line-height: 13px;
`;

export const SegmentTitle = styled.h6`
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 0;
`

export const Divider = styled.hr`
    border-top: 1px dashed #003B4A;
    margin: 2px;
`;

